export default "__VITE_ASSET__B67bfq2p__"